import { WSError } from 'api/utils';
import {
  tipoCFE,
  tipoMoneda,
  tipoPago,
  tipoEstadoVentas,
  getAllDocumentsURL,
  transformDateYYYMMDD,
  transformDateTime
} from './utils';
import { transformDate, formatImporte } from 'utils';
import Axios from 'axios';

export interface Document {
  estado: string;
  estadoEmpresas?: string;
  cfe: string;
  RawCfe: number;
  serie: string;
  numero: number;
  fecha: string;
  fechaAlta?: string;
  cliente: string;
  iva: string;
  subtotal: string;
  importe: string;
  moneda: string;
  tipoPago: string;
  pdf: string;
  disabled: boolean;
  pdfPayload: {
    id: number;
    fecha: string;
    docId: string;
    hash?: string;
    fechaGetTime: number;
  };
  anulado?: string;
  tipoCambio: string,
  observaciones?: string;
  oc?: string;
}

export const getAllDocuments = async (
  rut: string,
  id: number,
  isAccountant: boolean,
  desde: string,
  hasta: string
) => {
  const { data } = await Axios.get(
    getAllDocumentsURL(rut, isAccountant, desde, hasta),
    {
      timeout: 10000,
      responseType: 'json',
    }
  ).catch((error) => {
    throw new WSError('Documentos');
  });

  // console.log('getAllDocuments', {data});
  return formatDocument(data, id);
};

const formatDocument = (data: any[], id: number): Document[] =>
  data.map((item: any) => {
    let disabled = false;
    const estado = tipoEstadoVentas(item.FECabEstadoFactura?.trim());
    if (estado === 'Error' || estado === 'Rechazado') {
      disabled = true;
    }

    const cfe = item.Cobranza === 1 ? 'Recibo' : tipoCFE(item.FEIDDocTipoCFE);
    const ncRegex = /NC/;
    const isNC = ncRegex.test(cfe);

    const newItem: Document = {
      estado,
      estadoEmpresas: tipoEstadoVentas(item.FEEstadoEntreEmpresas?.trim() ?? ''),
      cfe,
      RawCfe: item.FEIDDocTipoCFE,
      serie: item.FEIDDocSerie,
      numero: item.FEIDDocNro,
      fecha: transformDate(item.FEIDDocFchEmis),
      fechaAlta: transformDate(item.FEFechaAlta),
      cliente: item.FERECRznSocRecep,
      iva: formatImporte(isNC ? item.IVA*-1 : item.IVA),
      subtotal: formatImporte(isNC ? item.Subtotal*-1 : item.Subtotal),
      importe: formatImporte(isNC ? item.FETOTMntPagar*-1 : item.FETOTMntPagar),
      moneda: tipoMoneda(item.FETOTTpoMoneda),
      tipoPago: item.Cobranza === 1 ? 'Cobranza' : tipoPago(item.FEIDDocFmaPago),
      tipoCambio: formatImporte(item.TC),
      pdfPayload: {
        id,
        fecha: transformDateYYYMMDD(item.FEFechaAlta),
        docId: item.FECabID,
        hash: item.FEHash,
        fechaGetTime: transformDateTime(item.FEFechaAlta)
      },
      pdf: '',
      disabled,
      anulado: item.Anulado,
      observaciones: item.FEAdenda,
      oc: item.FERECCompraId,
    };
    return newItem;
  });
